import { render } from "./Editor.vue?vue&type=template&id=4d05f41d"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"
script.render = render

export default script